import React from 'react'
import {UIGameFeedMessage} from '../UIGameFeedMessage/UIGameFeedMessage.tsx'

export function UIGameChatDebugMessage() {
    return (
        /* eslint-disable i18next/no-literal-string */
        <UIGameFeedMessage>
            userAgent: {navigator.userAgent}<br/>
            language: {navigator.language}<br/>
            cookieEnabled: {navigator.cookieEnabled}<br/>
            innerHeight: {window.innerHeight}<br/>
            innerWidth: {window.innerWidth}<br/>
            outerHeight: {window.outerHeight}<br/>
            outerWidth: {window.outerWidth}<br/>
        </UIGameFeedMessage>
    )
}
